import React, { Component } from 'react';
import { Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import './ChangeOrderTaskForm.css';
import FormTextArea from 'components/shared/form/FormTextArea';
import FormDateTimePicker from 'components/shared/form/FormDateTimePicker';
import ImageUpload from 'components/shared/image-upload/ImageUpload';
import { todayValidation } from 'services/utils/date-util';

class ChangeOrderTaskForm extends Component {
  constructor(props) {
    super(props);
    this.images = this.props.initialValues
      ? this.props.initialValues.images
      : [];
  }

  setImages = (props, files) => {
    let images = this.images.slice();
    this.images = [];
    files.forEach(function (val) {
      images.push({
        url: URL.createObjectURL(val),
        file: val,
      });
    });

    this.images = images;
    props.input.onChange(this.images);
  };

  removeImage = (props, index) => {
    this.images.splice(index, 1);
    props.input.onChange(this.images);
  };

  imagesComponent = (props) => {
    return (
      <ImageUpload
        extensions={['.jpg', '.jpeg', '.gif', '.png']}
        images={this.images}
        onRemove={(index) => this.removeImage(props, index)}
        onUpload={(files) => this.setImages(props, files)}
      />
    );
  };

  render() {
    const edit = !!this.props.initialValues;
    return (
      <div className="change-order-task-form">
        <Form horizontal onSubmit={this.props.handleSubmit}>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={4}>
              Target Completion Date
            </Col>
            <Col sm={8}>
              <Field
                component={FormDateTimePicker}
                isValidDate={todayValidation}
                name="completionDate"
                placeholder="Target Completion Date"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={4}>
              Description
            </Col>
            <Col sm={8}>
              <Field
                component={FormTextArea}
                name="description"
                placeholder="Description"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col sm={12}>
              <Field component={this.imagesComponent} name="images" />
            </Col>
          </FormGroup>
          {this.props.invalid && this.props.submitFailed && (
            <div className="invalid-message">
              The outlined inputs should be added in order to create a change
              order.
            </div>
          )}
          <FormGroup className="button-container">
            <Col sm={12}>
              <input
                className="btn button button-orange"
                type="submit"
                value={edit ? 'Update' : 'Create'}
              />
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};
  if (!values.completionDate) {
    errors.completionDate = 'Required';
  }
  if (!values.description) {
    errors.description = 'Required';
  }
  return errors;
}

export default reduxForm({
  form: 'ChangeOrderTaskForm',
  validate,
})(ChangeOrderTaskForm);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-order-tasks/ChangeOrderTaskForm.js